import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SeoHead, { orgSchema } from "@/components/SeoHead";
import OzyLogoMark from "@/components/OzyLogoMark";

export const COMPANY = {
  name: "OzyLoans",
  domain: "ozyloans.com.au",
  acl: "485752",
  afca: "618333",
  phone: "+61 426 976 876",
  phoneTel: "+61426976876",
  email: "mark@ozyloans.com.au",
  addressLine1: "Asian Pacific House",
  addressLine2: "Level 701/434 St Kilda Rd",
  addressLine3: "Melbourne VIC 3004",
};

export function ComplianceLayout({ title, kicker, seoTitle, description, path, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white font-outfit">
      <SeoHead
        title={seoTitle || title}
        description={description}
        path={path}
        schemas={[orgSchema()]}
      />
      <header className="px-6 sm:px-10 py-5 flex items-center justify-between border-b border-zinc-900">
        <Link to="/" className="font-bebas text-2xl tracking-[0.25em] text-zinc-300 hover:text-white flex items-center gap-2.5">
          <OzyLogoMark className="w-9 h-9" />
          <span>OZYLOANS<span className="text-[#E50914]">.</span></span>
        </Link>
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-500 hover:text-white text-xs uppercase tracking-widest">
          <ArrowLeft className="w-3 h-3" /> Back to site
        </Link>
      </header>

      <section className="max-w-3xl mx-auto px-6 py-16 sm:py-24" aria-labelledby="compliance-title">
        {kicker && <p className="text-xs uppercase tracking-[0.4em] text-[#E50914] mb-4">{kicker}</p>}
        <h1 id="compliance-title" className="font-bebas text-5xl sm:text-6xl tracking-tight leading-[0.95] mb-8">{title}</h1>
        <div className="prose prose-invert max-w-none text-zinc-300 leading-relaxed space-y-6 [&_h2]:font-bebas [&_h2]:text-2xl [&_h2]:tracking-wide [&_h2]:text-white [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:text-[15px] [&_li]:text-[15px] [&_strong]:text-white [&_a]:text-[#E50914] [&_a:hover]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5">
          {children}
        </div>
        <p className="text-zinc-600 text-xs mt-16 pt-8 border-t border-zinc-900">
          Last updated: {new Date().toLocaleDateString("en-AU", { year: "numeric", month: "long" })} · {COMPANY.name} · ACL #{COMPANY.acl}
        </p>
      </section>
    </div>
  );
}
